"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspectCardanoAddress = void 0;
var Loader_1 = require("../Loader");
function inspectCardanoAddress(addr) {
    var info;
    try {
        var addressShelley = Loader_1.default.CSL.Address.from_bech32(addr);
        info = {
            type: "Shelley",
            networkId: addressShelley.network_id()
        };
    }
    catch (err) {
        try {
            var addressByron = Loader_1.default.CSL.ByronAddress.from_base58(addr);
            info = {
                type: "Byron",
                networkId: addressByron.network_id()
            };
        }
        catch (err) {
            console.warn("Unknown address");
        }
    }
    return info;
}
exports.inspectCardanoAddress = inspectCardanoAddress;
